import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<h2 class=\"govuk-heading-l\">Sign in</h2><h3 class=\"govuk-heading-m\">Enter your password</h3><details class=\"govuk-details\" data-module=\"govuk-details\"><summary class=\"govuk-details__summary\"><span class=\"govuk-details__summary-text\"> I don&#39;t remember my password </span></summary><div class=\"govuk-details__text\"> If you don&#39;t remember your password please use the forgotten password link below. </div></details>", 3)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Forgotten password? ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Heading = _resolveComponent("Heading")!
  const _component_Form = _resolveComponent("Form")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Heading),
    _hoisted_1,
    _createVNode(_component_Form, {
      fields: _ctx.fields,
      buttons: _ctx.buttons,
      onFormHasPassedValidation: _ctx.saveFormData
    }, null, 8, ["fields", "buttons", "onFormHasPassedValidation"]),
    _createVNode(_component_router_link, {
      class: "govuk-link",
      to: { name: 'ForgottenPassword', params: { back: 'LoginFinish' } }
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    })
  ], 64))
}